/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"

import * as commonV1 from "./deviceapis_device_common_v1.pb"

/**
 * Сервис управления оповещением
 */

/**
 * Сервис управления оповещением
 */
export class SafeCityEmergencyServiceClient {
  /**
   * Конструктор сервиса
   * @param host Адрес хоста
   * @param token Токен доступа
   */
  constructor(
    public host = "",
    public token = ""
  ) { }

  /**
   * Старт оповещения.
   * Где Tick - один цикл оповещения на одном или двух направлениях (трубка, динамик или трубка и динамик).
   * playbacks_per_tick - Количество воспроизведений файла в каждом цикле оповещения на одном направлении (трубка или динамик).
   * tick_count - Количество воспроизведений циклов оповещения.
   * Длительность оповещения = tick_count * (Х * playbacks_per_tick (трубка) + Х * playbacks_per_tick (динамик)).
   * total_duration - Максимальная общая длительность оповещения. По истечении total_duration секунд оповещение прекращается независимо от количества циклов
   */
  PostSafeCityEmergencyStart = (req: PostSafeCityEmergencyStartRequestDto, init?: RequestInit): Promise<PostSafeCityEmergencyStartResponseDto> => {
    return fm.request<PostSafeCityEmergencyStartRequestDto, PostSafeCityEmergencyStartResponseDto>(`${this.host}/device/api/v1/safe_city/emergency/start`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Прекращение оповещения
   */
  PostSafeCityEmergencyStop = (req?: PostSafeCityEmergencyStopRequestDto, init?: RequestInit): Promise<PostSafeCityEmergencyStopResponseDto> => {
    return fm.request<PostSafeCityEmergencyStopRequestDto, PostSafeCityEmergencyStopResponseDto>(`${this.host}/device/api/v1/safe_city/emergency/stop`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Получение статуса оповещения
   */
  GetSafeCityEmergencyStatus = (req?: GetSafeCityEmergencyStatusRequestDto, init?: RequestInit): Promise<GetSafeCityEmergencyStatusResponseDto> => {
    return fm.request<GetSafeCityEmergencyStatusRequestDto, GetSafeCityEmergencyStatusResponseDto>(`${this.host}/device/api/v1/safe_city/emergency/status${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

}

/**
 * Тип проигрывания.
 */
export enum EmergencyScenarioPlayOrderType {
  /**
   * Значение не указано
   */
  PLAY_ORDER_TYPE_UNKNOWN = "PLAY_ORDER_TYPE_UNKNOWN",
  /**
   * Только на аналоговые трубки
   */
  HANDSET_ONLY = "HANDSET_ONLY",
  /**
   * Tолько на динамик домофона
   */
  SPEAKER_ONLY = "SPEAKER_ONLY",
  /**
   * Сначала на аналоговые трубки проигрываем заданное количество тактов, затем на динамик домофона
   */
  HANDSET_FIRST = "HANDSET_FIRST",
  /**
   * Сначала на динамик домофона проигрываем заданное количество тактов, затем на аналоговые трубки
   */
  SPEAKER_FIRST = "SPEAKER_FIRST",
  /**
   * Одновременно на аналоговые трубки проигрываем заданное количество тактов, затем на динамик домофона
   */
  HANDSET_AND_SPEAKER = "HANDSET_AND_SPEAKER",
}
/**
 * Тип проигрывания.
 */
export type EmergencyScenarioPlayOrderTypeResponseEnum = keyof typeof EmergencyScenarioPlayOrderType
/**
 * Тип проигрывания.
 */
export type EmergencyScenarioPlayOrderTypeRequestEnum = Exclude<EmergencyScenarioPlayOrderTypeResponseEnum, "PLAY_ORDER_TYPE_UNKNOWN">;

/**
 * Сценарий оповещения
 */
export type EmergencyScenarioRequestDto = {
  /**
   * Имя файла
   */
  fileName: string
  /**
   * Максимальная общая длительность оповещения, в секундах.
   * # Диапазон: 0..65536
   */
  totalDuration: number
  /**
   * Количество воспроизведений файла в каждом цикле оповещения на одном направлении (трубка или динамик).
   * # Диапазон: 0..65536
   */
  playbackPerTick: number
  /**
   * Количество воспроизведений циклов оповещения.
   * # Диапазон: 0..65536
   */
  tickCount: number
  /**
   * Тип проигрывания
   */
  playOrderType: EmergencyScenarioPlayOrderTypeRequestEnum
}
/**
 * Сценарий оповещения
 */
export type EmergencyScenarioResponseDto = {
  /**
   * Имя файла
   */
  fileName: string
  /**
   * Максимальная общая длительность оповещения, в секундах.
   * # Диапазон: 0..65536
   */
  totalDuration: number
  /**
   * Количество воспроизведений файла в каждом цикле оповещения на одном направлении (трубка или динамик).
   * # Диапазон: 0..65536
   */
  playbackPerTick: number
  /**
   * Количество воспроизведений циклов оповещения.
   * # Диапазон: 0..65536
   */
  tickCount: number
  /**
   * Тип проигрывания
   */
  playOrderType: EmergencyScenarioPlayOrderTypeResponseEnum
}
/**
 * Запрос на получение статуса оповещения
 */
export type GetSafeCityEmergencyStatusRequestDto = {
}
/**
 * Ответ на запрос на получение статуса оповещения
 */
export type GetSafeCityEmergencyStatusResponseDto = {
  /**
   * Статус оповещения
   */
  data: GetSafeCityEmergencyStatusResponseCurrentStatusDto | null
}
/**
 * Статус оповещения
 */
export type GetSafeCityEmergencyStatusResponseCurrentStatusDto = {
  /**
   * Признак работающего оповещения в текущий момент
   */
  isRunning: boolean
  /**
   * Тип проигрывания
   */
  emergencyScenarioPlayOrderType: EmergencyScenarioPlayOrderTypeResponseEnum
  /**
   * Имя файла
   */
  fileName: string
}
/**
 * Запрос на старт оповещения
 */
export type PostSafeCityEmergencyStartRequestDto = {
  /**
   * Сценарий оповещения
   */
  data: EmergencyScenarioRequestDto
}
/**
 * Ответ на запрос на старт оповещения
 */
export type PostSafeCityEmergencyStartResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Ошибка
   */
  readonly error: PostSafeCityEmergencyStartResponseErrorDto
}>
/**
 * Ошибка запроса
 */
export type PostSafeCityEmergencyStartResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: commonV1.ValidationErrorRequestDto
  /**
   * Звуковой файл не найден
   */
  readonly soundFileNotFound: PostSafeCityEmergencyStartResponseErrorSoundFileNotFoundRequestDto
}>
/**
 * Ошибка запроса
 */
export type PostSafeCityEmergencyStartResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: commonV1.ValidationErrorResponseDto
  /**
   * Звуковой файл не найден
   */
  readonly soundFileNotFound: PostSafeCityEmergencyStartResponseErrorSoundFileNotFoundDto
}>
/**
 * Звуковой файл не найден
 */
export type PostSafeCityEmergencyStartResponseErrorSoundFileNotFoundRequestDto = {
}
/**
 * Звуковой файл не найден
 */
export type PostSafeCityEmergencyStartResponseErrorSoundFileNotFoundDto = {
}
/**
 * Запрос на прекращение оповещения через домофон
 */
export type PostSafeCityEmergencyStopRequestDto = {
}
/**
 * Ответ на запрос на прекращение оповещения через домофон
 */
export type PostSafeCityEmergencyStopResponseDto = {
}
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Сценарий оповещения
   */
  "EmergencyScenario": {
    "kind": "class",
    "text": "Сценарий оповещения",
    "fields": {
      /**
       * Имя файла
       */
      "fileName": {
        "type": "string",
        "text": "Имя файла",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Максимальная общая длительность оповещения, в секундах.
       * # Диапазон: 0..65536
       */
      "totalDuration": {
        "type": "int32",
        "text": "Максимальная общая длительность оповещения, в секундах.\n# Диапазон: 0..65536",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 65536,
            "message": "Значение не входит в допустимый диапазон. Максимум: 65536"
          },
        }
      },
      /**
       * Количество воспроизведений файла в каждом цикле оповещения на одном направлении (трубка или динамик).
       * # Диапазон: 0..65536
       */
      "playbackPerTick": {
        "type": "int32",
        "text": "Количество воспроизведений файла в каждом цикле оповещения на одном направлении (трубка или динамик).\n# Диапазон: 0..65536",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 65536,
            "message": "Значение не входит в допустимый диапазон. Максимум: 65536"
          },
        }
      },
      /**
       * Количество воспроизведений циклов оповещения.
       * # Диапазон: 0..65536
       */
      "tickCount": {
        "type": "int32",
        "text": "Количество воспроизведений циклов оповещения.\n# Диапазон: 0..65536",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 65536,
            "message": "Значение не входит в допустимый диапазон. Максимум: 65536"
          },
        }
      },
      /**
       * Тип проигрывания
       */
      "playOrderType": {
        "type": "EmergencyScenario.PlayOrderType",
        "text": "Тип проигрывания",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Запрос на получение статуса оповещения
   */
  "GetSafeCityEmergencyStatusRequest": {
    "kind": "class",
    "text": "Запрос на получение статуса оповещения",
  },
  /**
   * Ответ на запрос на получение статуса оповещения
   */
  "GetSafeCityEmergencyStatusResponse": {
    "kind": "class",
    "text": "Ответ на запрос на получение статуса оповещения",
    "fields": {
      /**
       * Статус оповещения
       */
      "data": {
        "type": "GetSafeCityEmergencyStatusResponse.CurrentStatus",
        "text": "Статус оповещения",
      },
    },
  },
  /**
   * Статус оповещения
   */
  "GetSafeCityEmergencyStatusResponse.CurrentStatus": {
    "kind": "class",
    "text": "Статус оповещения",
    "fields": {
      /**
       * Признак работающего оповещения в текущий момент
       */
      "isRunning": {
        "type": "bool",
        "text": "Признак работающего оповещения в текущий момент",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Тип проигрывания
       */
      "emergencyScenarioPlayOrderType": {
        "type": "EmergencyScenario.PlayOrderType",
        "text": "Тип проигрывания",
      },
      /**
       * Имя файла
       */
      "fileName": {
        "type": "string",
        "text": "Имя файла",
      },
    },
  },
  /**
   * Запрос на старт оповещения
   */
  "PostSafeCityEmergencyStartRequest": {
    "kind": "class",
    "text": "Запрос на старт оповещения",
    "fields": {
      /**
       * Сценарий оповещения
       */
      "data": {
        "type": "EmergencyScenario",
        "text": "Сценарий оповещения",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос на старт оповещения
   */
  "PostSafeCityEmergencyStartResponse": {
    "kind": "class",
    "text": "Ответ на запрос на старт оповещения",
    "fields": {
      /**
       * Ошибка
       */
      "error": {
        "type": "PostSafeCityEmergencyStartResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса
   */
  "PostSafeCityEmergencyStartResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
      /**
       * Звуковой файл не найден
       */
      "soundFileNotFound": {
        "type": "PostSafeCityEmergencyStartResponse.Error.SoundFileNotFound",
        "text": "Звуковой файл не найден",
      },
    },
  },
  /**
   * Звуковой файл не найден
   */
  "PostSafeCityEmergencyStartResponse.Error.SoundFileNotFound": {
    "kind": "class",
    "text": "Звуковой файл не найден",
  },
  /**
   * Запрос на прекращение оповещения через домофон
   */
  "PostSafeCityEmergencyStopRequest": {
    "kind": "class",
    "text": "Запрос на прекращение оповещения через домофон",
  },
  /**
   * Ответ на запрос на прекращение оповещения через домофон
   */
  "PostSafeCityEmergencyStopResponse": {
    "kind": "class",
    "text": "Ответ на запрос на прекращение оповещения через домофон",
  },
  /**
   * Тип проигрывания.
   */
  "EmergencyScenario.PlayOrderType": {
    "kind": "enum",
    "text": "Тип проигрывания.",
    "values": {
      /**
       * Значение не указано
       */
      "PLAY_ORDER_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Только на аналоговые трубки
       */
      "HANDSET_ONLY": {
        "i": 1,
        "text": "Только на аналоговые трубки",
      },
      /**
       * Tолько на динамик домофона
       */
      "SPEAKER_ONLY": {
        "i": 2,
        "text": "Tолько на динамик домофона",
      },
      /**
       * Сначала на аналоговые трубки проигрываем заданное количество тактов, затем на динамик домофона
       */
      "HANDSET_FIRST": {
        "i": 3,
        "text": "Сначала на аналоговые трубки проигрываем заданное количество тактов, затем на динамик домофона",
      },
      /**
       * Сначала на динамик домофона проигрываем заданное количество тактов, затем на аналоговые трубки
       */
      "SPEAKER_FIRST": {
        "i": 4,
        "text": "Сначала на динамик домофона проигрываем заданное количество тактов, затем на аналоговые трубки",
      },
      /**
       * Одновременно на аналоговые трубки проигрываем заданное количество тактов, затем на динамик домофона
       */
      "HANDSET_AND_SPEAKER": {
        "i": 5,
        "text": "Одновременно на аналоговые трубки проигрываем заданное количество тактов, затем на динамик домофона",
      },
    },
  },
}